module.exports = "/_next/static/images/56db2851873d3c5cc04e7e7520d32680-rewards-hosting@0.75x.png.webp";